import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOptionCorrectAnswerCheckedIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 19,
	viewBox: "0 0 20 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M4.5 10.5L8 14L16 6",
		stroke: "currentColor",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) })
});
export default SvgOptionCorrectAnswerCheckedIcon;
